import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl';
import commonFunctions from '../../utils/commonFunctions'
import API from '../../utils/API'
import InputValidation from '../../utils/InputValidation';
 
function LicenseModal(props) {
  const { 
    setResetLicenseModalRef,
    activateError, setActivateError, 
    success, setSuccess,
    error, setError,
    closeModal,
    activateInfo, setActivateInfo,
    butDisabled, setButDisabled,
    setRefreshingAdd,
    refreshLicenses,
  } = props;

  const [licenseKey, setLicenseKey] = useState(''); 
  const [licensesKeyValid, setLicensesKeyValid] = useState('');
  const [submitted, setSubmitted] = useState(false);

  /**
   * Activates license
   * @param {Event} e 
   */
   function handleAddLicense(e) {
    e.preventDefault();
    setActivateError('');
    setSubmitted(true);
    validateLicenseKey(licenseKey);
    if (licensesKeyValid)
      return;
    setActivateInfo(<FormattedMessage id="LICENSE_ACTIVATED_INFO" />);
    setButDisabled('disabled');
    setRefreshingAdd(true);
    API.activateLicense(licenseKey)
    .then((res)=>{
      refreshLicenses();
      setSuccess(<FormattedMessage id="LICENSE_ACTIVATED_SUCCESS" />);
      closeModal("licenseModal");
    })
    .catch((err)=>{
      console.error(err);
      if(err.response.data.includes('Product Id')) {
        setError(<FormattedMessage id="LICENSE_ALREADY_ACTIVATED" />);
        setActivateError(<FormattedMessage id="LICENSE_ALREADY_ACTIVATED" />);
      } else if (err.response.data.includes('invalid')) {
        setError(<FormattedMessage id="ACTIVATION_KEY_INVALID" />);
        setActivateError(<FormattedMessage id="ACTIVATION_KEY_INVALID" />);
      } else {
        setError(err.message);
        setActivateError(err.message);
      }
    })
    .finally(()=>{
      setRefreshingAdd(false);
      setButDisabled('');
      setActivateInfo('');
    });
  }

  // Perform field validations using a single useEffect
  useEffect(() => {
    // Perform field validations
    validateLicenseKey(licenseKey);
  }, [licenseKey]);

  const validateLicenseKey = (value) => {
    setLicensesKeyValid(InputValidation.validateLicensesKey(value));
  };

  const handleLicenseKeyChange = (value) => {
    setLicenseKey(value);
    validateLicenseKey(value);
  };

  useEffect(() => {
    setResetLicenseModalRef(resetModal);
  }, [setResetLicenseModalRef]);

  const resetModal = () => {
    console.log('resetting')
    setSuccess('');
    setError(''); 
    setRefreshingAdd(false);
    setButDisabled('');
    setActivateInfo('');
    setActivateError('');
    setLicenseKey('');
  }

  return (
    <div className="modal fade" id="licenseModal" tabIndex="-1" aria-labelledby="licenseModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"><FormattedMessage id="ACTIVATE_LICENSE" /></h5>
            <button type="button" id="btn-close" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=>setActivateError('')}></button>
          </div>
          <div className="modal-body">
            <form>
              <div className="row">
                <div className="col mb-3">
                  <label htmlFor="name" className="col-form-label"><FormattedMessage id="LICENSE_KEY" /><FormattedMessage id="SYMBOL_COLON" /></label>
                  <input id="licenseKeyInput" onChange={(e) => handleLicenseKeyChange(e.target.value)} value={licenseKey} type="text" className={`form-control ${submitted && !licensesKeyValid ? "is-valid" : submitted && licensesKeyValid ? "is-invalid" : ""}`} name="licenseKey" />
                  {commonFunctions.InvalidFeedbackString(licensesKeyValid, "LICENSE_KEY")}
                </div>
              </div>
              <div className='text-danger' style={{fontSize: 12}}>{activateError}</div>
              <div className='text-success' style={{fontSize: 12}}>{success}</div>
              <div className='text-info' style={{fontSize: 12}}>{activateInfo}</div>
            </form>
          </div>
          <div className="modal-footer">
            <button id="licenseActivateBtn" type="button" className="btn save-btn" disabled={butDisabled} onClick={handleAddLicense}><FormattedMessage id="SAVE" /></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LicenseModal